// discoveryStateSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ConnectionListResponse } from './ApplicationCard';

export interface DiscoveryConnectionListState {
  loading: boolean;
  errorData: object | unknown;
  data: ConnectionListResponse | null;
}

const initialState: DiscoveryConnectionListState = {
  loading: false,
  errorData: null,
  data: null,
};

const discoveryConnectionListSlice = createSlice({
  name: 'discoveryConnectionList',
  initialState,
  reducers: {
    setDiscoveryConnectionListLoading: (
      state,
      action: PayloadAction<boolean>
    ) => ({
      ...state,
      loading: action.payload,
    }),
    setDiscoveryConnectionListError: (
      state,
      action: PayloadAction<object | unknown>
    ) => ({
      ...state,
      errorData: action.payload,
    }),
    setDiscoveryConnectionListState: () => initialState,
  },
});

export const {
  setDiscoveryConnectionListError,
  setDiscoveryConnectionListLoading,
  setDiscoveryConnectionListState,
} = discoveryConnectionListSlice.actions;
export default discoveryConnectionListSlice;
